import { useMemo } from 'react';

import type { CatalogItem } from '@/entities/catalog-item';

/**
 * Narrows the catalog to the single code targeted by a "View in …" jump.
 *
 * Applied as a pipeline step (not a TanStack column filter — the `Code` column
 * filter is owned by "Show selected only"). Returns the input array unchanged
 * when no code is set, so downstream memoisation and the "no filter" path stay
 * referentially stable.
 */
export const useCodeFilteredData = (data: CatalogItem[], code: string | null): CatalogItem[] => {
  return useMemo(() => {
    const target = code?.trim().toUpperCase();
    if (!target) return data;
    return data.filter(item => item.Code.trim().toUpperCase() === target);
  }, [data, code]);
};
